module.exports = __webpack_public_path__ + "static/background.b8bf76c6.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/background.jpeg
// module id = 545
// module chunks = 2 3 4